// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".s-module__loading--weHlE {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 60px 0;\n}\n", "",{"version":3,"sources":["webpack://./src/pages/dashboard/FinancialsPage/components/InsuranceBillingTab/s.module.less"],"names":[],"mappings":"AAAA;EACI,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;AACJ","sourcesContent":[".loading {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 60px 0;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loading": "s-module__loading--weHlE"
};
export default ___CSS_LOADER_EXPORT___;
